import React from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const FooterNewsletter = () => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });
	const { register, handleSubmit } = useForm();
	const history = useHistory();

	const onSubmit = (data) => {
		history.push({
			pathname: "/boletin/ingresar-datos",
			search: `?email=${decodeURIComponent(data?.email || "")}`,
		});
	};

	return (
		<section className="footer-newsletter" aria-labelledby="footer-newsletter-title">
			<div className="footer-newsletter__header">
				<div>
					<h3 id="footer-newsletter-title">
						{footerTexts.getText({
							id: "newsletter.title",
							defaultText: "Suscríbete a nuestro newsletter",
						})}
					</h3>
				</div>
			</div>
			<form className="footer-newsletter__form" onSubmit={handleSubmit(onSubmit)}>
				<input
					className="form-control focusable-secondary"
					type="email"
					placeholder={footerTexts.getText({
						id: "newsletter.email.placeholder",
						defaultText: "Correo electrónico",
					})}
					aria-label={footerTexts.getText({
						id: "newsletter.email.placeholder",
						defaultText: "Correo electrónico",
					})}
					{...register("email", { required: true })}
					required
				/>
				<button className="buttonv2 button-primary focusable-red" type="submit">
					{footerTexts.getText({ id: "newsletter.submit", defaultText: "Suscribirme" })}
				</button>
			</form>
			<p className="footer-newsletter__terms">
				{footerTexts.getText({
					id: "newsletter.terms.prefix",
					defaultText: "Al ingresar tus datos estás aceptando",
				})}{" "}
				<Link className="focusable-secondary" to="/terminos-y-condiciones">
					{footerTexts.getText({
						id: "newsletter.terms.conditions",
						defaultText: "Términos y condiciones",
					})}
				</Link>{" "}
				{footerTexts.getText({ id: "newsletter.terms.and", defaultText: "y" })}{" "}
				<Link className="focusable-secondary" to="/politica-de-privacidad">
					{footerTexts.getText({
						id: "newsletter.terms.privacy",
						defaultText: "Política de privacidad",
					})}
				</Link>
			</p>
		</section>
	);
};
